import { actions, selectors } from '@groove-labs/groove-ui';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CONFIRMATION_DIALOG_KEY_PATH } from 'Modules/Shared/constants';
import UserActionDialog from 'Modules/Shared/components/UserActionDialog';
import ClariTheme from 'Utils/theme/ClariTheme';

type ConfirmationDialogPropTypes = {
  onConfirm: () => void;
  type: string;
  title?: string;
  submitText?: string;
  cancelText?: string;
};

const { setProperty } = actions.ui;
const { getProperty } = selectors.ui;

const ConfirmationDialog: React.FC<ConfirmationDialogPropTypes> = ({
  onConfirm,
  type,
  title = 'Are you sure?',
  submitText = 'OK',
  cancelText = 'Cancel',
}) => {
  const dispatch = useDispatch();

  const handleSubmit = React.useCallback(() => {
    onConfirm();
    dispatch(
      setProperty({
        uiKeyPath: CONFIRMATION_DIALOG_KEY_PATH,
        data: {
          [type]: false,
        },
      })
    );
  }, [dispatch, onConfirm, type]);

  const handleCancel = React.useCallback(() => {
    dispatch(
      setProperty({
        uiKeyPath: CONFIRMATION_DIALOG_KEY_PATH,
        data: {
          [type]: false,
        },
      })
    );
  }, [dispatch, type]);

  const isOpen = useSelector(state =>
    getProperty(state, [...CONFIRMATION_DIALOG_KEY_PATH, type], false)
  );

  return (
    <UserActionDialog
      title={title}
      open={isOpen}
      buttons={[
        {
          text: submitText,
          onClick: handleSubmit,
        },
        {
          text: cancelText,
          onClick: handleCancel,
          color: ClariTheme.palette.text.secondary,
        },
      ]}
    />
  );
};

export default ConfirmationDialog;
